var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('a',{staticStyle:{"color":"inherit"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.loginOut()}}},[_c('Icon',{staticStyle:{"margin-right":"10px"},attrs:{"type":"ios-exit-outline"}}),_vm._v("退出")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }